import React, { useState } from 'react'

import {
  // Link as RouterLink,
  NavLink,
  Route,
  Routes,
  // useLocation
} from 'react-router-dom'

import useFirebase from 'hooks/firebase'

import {
  AppBar,
  Box,
  CardActionArea,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  Toolbar,
  Typography,
} from '@mui/material'

import LogoutIcon from '@mui/icons-material/Logout'
import MenuIcon from '@mui/icons-material/Menu'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  faFlag,
  faHandsHoldingCircle,
  faHouse,
  faSchool,
} from '@fortawesome/free-solid-svg-icons'

import Schools from './schools'
import Virtues from './virtues'
import Goals from './goals'
import SchoolDetails from './schools/details'

const Admin = (props) => {
  const { window } = props
  const drawerWidth = 96

  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const { auth } = useFirebase()
  const { logout } = auth

  const sections = [
    { id: 0, label: 'Inicio', icon: <FontAwesomeIcon icon={faHouse} />, path: '' },
    { id: 1, label: 'Escuelas', icon: <FontAwesomeIcon icon={faSchool} />, path: 'escuelas' },
    { id: 2, label: 'Virtudes', icon: <FontAwesomeIcon icon={faHandsHoldingCircle} />, path: 'virtudes' },
    { id: 3, label: 'Metas', icon: <FontAwesomeIcon icon={faFlag} />, path: 'metas' },
  ]

  const drawer = (
    <>
      <Toolbar>
        <Grid container>
          <Grid item xs align='middle'>
            <Box
              component='img'
              src='/assets/images/lightspot_logo.png'
              sx={{ py: 3, width: '100%' }}
            />
          </Grid>
        </Grid>
      </Toolbar>
      <List sx={{ p: 0 }}>
      {
        sections.map((section) => (
          <ListItem 
            key={`section_${section.id}`}
            button
            dense
            component={NavLink}
            end // https://stackoverflow.com/a/70551865
            to={section.path}
            onClick={handleDrawerToggle}
            style={({ isActive }) => ({
              background: isActive ? '#ffffff22' : ''
            })}
            sx={{ '&:hover': { background: '#ffffff22', }, }}
          >
            <Grid container spacing={0} color='white' align='center' sx={{ p: 1 }}>
              <Grid item xs={12}>
                {section.icon}
              </Grid>
              <Grid item xs={12}>
                <Typography variant='caption'>
                  {section.label}
                </Typography>
              </Grid>
            </Grid>
          </ListItem>
        ))
      }
      </List>
      <Box sx={{ marginTop: 'auto' }}>
        <Grid container spacing={2}>
          {/* <Grid item xs={12} align='center'>
            <Avatar
              alt='Profile Picture'
              src={formatProfilePicture(user.photoUrl, user.authProvider)}
              sx={{ width: 64, height: 64 }}
            />
          </Grid> */}
          {/* <Grid item xs={12} align='center'>
            <Typography variant='body2'>
              { user.name }
            </Typography>
            <Typography variant='caption'>
              { user.email }
            </Typography>
          </Grid> */}
          <Grid item xs={12}>
            {/* <Button
              color='primary'
              disableElevation
              fullWidth
              onClick={logout}
              size='small'
              variant='contained'
            >
              Cerrar sesión
            </Button> */}
            <CardActionArea onClick={logout}>
              <Grid container spacing={0} color='white' align='center' sx={{ p: 1 }}>
                <Grid item xs={12}>
                  <LogoutIcon />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='caption'>
                    Cerrar sesión
                  </Typography>
                </Grid>
              </Grid>
            </CardActionArea>
          </Grid>
        </Grid>
      </Box>
    </>
  )

  const container = window !== undefined ? () => window().document.body : undefined

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        color='secondary'
        position='absolute'
        sx={{
          boxShadow: 'none',
          display: { xs: 'flex', md: 'none' },
          ml: `${drawerWidth}px`,
          // width: `calc(100% - ${drawerWidth}px)`,
        }}
      >
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {/* <Typography variant='h6' noWrap component='div'>
            <b>EL PAÍS</b>
          </Typography> */}
          {/* <Box
            component='img'
            src='/assets/images/el-pais-logo.png'
            sx={{ height: 24 }}
          /> */}
          {/* <Box sx={{ flexGrow: 1 }}>
            
          </Box> */}
        </Toolbar>
      </AppBar>
      <Drawer
        // anchor='left'
        container={container}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          display: { xs: 'block', md: 'none' },
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            borderWidth: 0,
            boxSizing: 'border-box',
            width: drawerWidth
          },
          width: drawerWidth,
        }}
        variant='temporary'
      >
        { drawer }
      </Drawer>
      <Drawer
        sx={{
          display: { xs: 'none', md: 'block' },
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            borderWidth: 0,
            boxSizing: 'border-box',
            borderBottomRightRadius: 16,
            borderTopRightRadius: 16,
            width: drawerWidth,
            bgcolor: '#4d4084'
          },
          width: drawerWidth,
        }}
        variant='permanent'
        anchor='left'
      >
        { drawer }
      </Drawer>
      <Box
        component='main'
        sx={{ bgcolor: 'background.default', flexGrow: 1, p: { xs: 0, md: 2 } }}
      >
        <Toolbar sx={{ display: { xs: 'flex', md: 'none' } }}/>
        {/* <Page sx={{ display: { xs: 'none', md: 'flex' } }}/> */}
        <Routes>
          <Route path='escuelas' element={<Schools />} />
          <Route path='escuelas/:id' element={<SchoolDetails />} />
          <Route path='virtudes' element={<Virtues />} />
          <Route path='metas' element={<Goals />} />
        </Routes>
      </Box>
    </Box>
  )
}

export default Admin